// extracted by css-extract-rspack-plugin
export default {"cls1":"step_two-cls1_EJX","cls2":"step_two-cls2_ldI step_two-cls1_EJX"};